function abusController(DatatableLang, $state, $scope, WS, $window ,$translate) {
    'ngInject';
    const vm = this;
    vm.regions = {};
    vm.filter = {};
    vm.filter.user_code = '';
    vm.filter.depot_code = '';
    vm.filter.date_debut = '';
    vm.filter.date_fin = '';;
    vm.getAbusFrigo = function() {
        WS.getData('abus_frigo', vm.filter)
            .then(function(response) {
                if (response.status == 200) {
                    vm.abus_frigo = response.data;
                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };
}
export default {
    name: 'abusController',
    fn: abusController
};